import i18next from "i18next";

export const apiBaseUrl = (process.env.NODE_ENV === 'development' ? 'https://ecojer.kz' : '') + '/api';

export const apiAdminUrl = apiBaseUrl + '/admin';

export const interceptorsConfig = (config) => {
    const token = localStorage.getItem('token');
    const lang = i18next.language;

    config.headers.Authorization = token ? `Bearer ${token}` : null;
    config.headers.language = lang ? lang : 'en';

    return config;
}